import { render, staticRenderFns } from "./component-table.vue?vue&type=template&id=77e70e50"
import script from "./component-table.vue?vue&type=script&lang=js"
export * from "./component-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports